import CategoriesTable from './CategoriesTable'

export default CategoriesTable



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/CategoriesTab/CategoriesTable/index.js